import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import Footer from './Common/Footer';

const Page = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        width: '100%',
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          width: '100%',
        }}
      >
        <Outlet/>
      </Box>
      <Footer/>
    </Box>
  );
};

export default Page;
